import { useTranslation } from "react-i18next";
import { useState } from "react";
import logoPandin from "./img/logo_wide.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTelegram,
  faWhatsapp,
  faLinkedin,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

function Footer() {
  const { t } = useTranslation();
  var footerItems = t("Footer", { returnObjects: true });

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  const location = useLocation();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !message) {
      setStatus("Preencha todos os campos.");
      return;
    }
    setStatus("Enviando...");
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      formData.append("message", message);

      const response = await fetch("https://api.pandin.dev/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      if (response.ok) {
        setStatus("Mensagem enviada!");
        setEmail("");
        setMessage("");
      } else {
        setStatus("Erro ao enviar. Tente novamente.");
      }
    } catch {
      setStatus("Erro ao enviar. Tente novamente.");
    }
  };

  // Função para resetar status ao tentar novamente após erro
  const handleTryAgain = () => {
    setStatus("");
  };

  // Função para navegação SPA e scroll suave igual ao Navbar
  const handleFooterLinkClick = (e, path) => {
    e.preventDefault();
    if (!path) return;
    if (path === "/") {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      return;
    }
    if (path.startsWith("#")) {
      // Sempre navega para home antes de scrollar para anchors
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          const sectionId = path.replace("#", "");
          const element = document.getElementById(sectionId);
          if (element) {
            const y = element.getBoundingClientRect().top + window.pageYOffset - 40;
            window.scrollTo({ top: y, behavior: "smooth" });
          }
        }, 100);
      } else {
        const sectionId = path.replace("#", "");
        const element = document.getElementById(sectionId);
        if (element) {
          const y = element.getBoundingClientRect().top + window.pageYOffset - 40;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }
    } else if (path.includes("#")) {
      const [basePath, sectionId] = path.split("#");
      if (location.pathname === basePath) {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        navigate(basePath);
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      }
    } else if (path === "/tools") {
      if (location.pathname !== "/tools") {
        navigate("/tools");
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      return;
    } else {
      navigate(path);
    }
  };

  return (
    <div className="container-fluid footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 first-section">
            <div className="row">
              <div className="col-lg-12 d-flex justify-content-center align-items-center gap-2">
                <img
                  src={logoPandin}
                  alt="Logo Pandin"
                  className="logo-pandin"
                />
              </div>
              <div className="col-lg-12 d-flex justify-content-center align-items-center gap-2 mt-2">
                <p className="text-white">{footerItems.FullStack}</p>
              </div>
              <div className="col-lg-12 d-flex justify-content-center align-items-center gap-2">
                <p className="footer-desc text-white-100 text-center small mb-0">
                  {footerItems.FooterDesc}
                </p>
              </div>
              <div className="col-lg-12 d-flex justify-content-center align-items-center gap-2 mt-2">
                {/* Adiciona o link Home */}
                <a
                  href="/"
                  className="footer-link text-white-70 small mx-1"
                  onClick={(e) => handleFooterLinkClick(e, "/")}
                >
                  Home
                </a>
                <a
                  href="#about"
                  className="footer-link text-white-70 small mx-1"
                  onClick={(e) => handleFooterLinkClick(e, "#about")}
                >
                  {footerItems.LinkAbout}
                </a>
                <a
                  href="#projects"
                  className="footer-link text-white-70 small mx-1"
                  onClick={(e) => handleFooterLinkClick(e, "#projects")}
                >
                  {footerItems.LinkProjects}
                </a>
                <a
                  href="#tools"
                  className="footer-link text-white-70 small mx-1"
                  onClick={(e) => handleFooterLinkClick(e, "/tools")}
                >
                  {footerItems.LinkTools}
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 second-section">
            <div className="footer-contact-title text-white mb-2 fw-bold fs-5">
              {footerItems.ContactTitle}
            </div>
            <form
              onSubmit={
                status === "Erro ao enviar. Tente novamente."
                  ? handleTryAgain
                  : handleSubmit
              }
              className="footer-contact-form d-flex flex-column align-items-center gap-2"
            >
              <input
                type="email"
                className="form-control"
                placeholder="Seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <textarea
                className="form-control"
                placeholder="Sua mensagem"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={2}
                required
              />
              {(!status || status === "Enviando...") && (
                <button
                  type="submit"
                  className={`btn ${
                    status === "Mensagem enviada!"
                      ? "btn-success"
                      : "btn-primary"
                  }`}
                  disabled={status === "Enviando..."}
                >
                  {status === "Enviando..." ? "Enviando..." : "Enviar"}
                </button>
              )}
              {status === "Mensagem enviada!" && (
                <div className="mt-2 text-success">{status}</div>
              )}
              {status === "Erro ao enviar. Tente novamente." && (
                <button
                  type="button"
                  className="btn btn-danger mt-2"
                  onClick={handleTryAgain}
                >
                  {status}
                </button>
              )}
              {status === "Preencha todos os campos." && (
                <div className="mt-2 text-danger">{status}</div>
              )}
            </form>
          </div>
          <div className="col-lg-4 third-section">
            <div className="row">
              <div className="col-lg-12 d-flex justify-content-center align-items-center gap-2">
                <p className="text-white">{footerItems.FollowMe}</p>
              </div>
              <div className="col-lg-12 d-flex justify-content-center align-items-center gap-2">
                <span className="footer-invite text-white-70 small">
                  {footerItems.FooterInvite}
                </span>
              </div>
              <div className="col-lg-12 d-flex justify-content-center align-items-center gap-3 social-media">
                <Link
                  to="https://t.me/pandin"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <FontAwesomeIcon icon={faTelegram} />
                </Link>
                <Link
                  to="https://wa.me/5511963840038"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </Link>
                <Link
                  to="https://linkedin.com/in/pandin"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <FontAwesomeIcon icon={faLinkedin} />
                </Link>
                <Link
                  to="https://x.com/pandindev"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <FontAwesomeIcon icon={faXTwitter} />
                </Link>
                <Link
                  to="mailto:pandin@pandin.dev"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row display-flex flex-column justify-content-center align-items-center gap-1 m-4">
          <div
            className="text-white"
            dangerouslySetInnerHTML={{ __html: footerItems.Copyright }}
          ></div>
          <div
            className="text-white"
            dangerouslySetInnerHTML={{ __html: footerItems.DevelopedBy }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
